import classNames from "classnames";

import { CaseDetailState } from "shared/reducers/caseDetailReducer";
import { specimen_source } from "shared/utils/specimenUtils";

import { DiagnosesObject } from "../CaseReport.types";
import {
  isDiagnosisCritical,
  isDiagnosisRed,
  seeNoteOnDiagnosis,
} from "../utils";

const DiagnosesInformation = ({
  isTechnicalReport = false,
  isPrelimReport = false,
  diagnoses = [] as DiagnosesObject[],
  caseDetailObject,
}: {
  isTechnicalReport: boolean;
  isPrelimReport: boolean;
  diagnoses: DiagnosesObject[];
  caseDetailObject: CaseDetailState;
}) => {
  const upperCaseReportDiag =
    caseDetailObject.accessioning_lab?.settings?.uppercase_report_diagnosis
      ?.active;
  const changeCriticalDiagnosis =
    caseDetailObject.accessioning_lab?.settings
      ?.format_report_critical_diagnoses?.active;
  return !isTechnicalReport ? (
    <section className="PrintReportSection">
      <h2 className="PrintReportSection__header">
        {isPrelimReport ? "Preliminary" : "Final"} Diagnosis:
      </h2>
      <table className="PrintReportSection__table">
        <tbody className="PrintReport__diagnosis">
          {diagnoses.map((diag, index) => {
            const isCritical = isDiagnosisCritical(diag.diagnosis);
            const redDiag = isDiagnosisRed(
              caseDetailObject.patient?.clinic,
              changeCriticalDiagnosis
            );

            const specimenSource = specimen_source(diag.specimen);
            return (
              <tr
                key={index}
                className={classNames({
                  "PrintReport__diagnosis--critical": isCritical && redDiag,
                })}
              >
                <td className="PrintReportSection__table--removeWrap">
                  {diag.specimen.name}.
                </td>
                <td>
                  <span className="PrintReport__diagnosis--diagnosis">
                    {upperCaseReportDiag
                      ? specimenSource?.toUpperCase()
                      : specimenSource}
                    :
                    <br />
                    {(upperCaseReportDiag
                      ? seeNoteOnDiagnosis(
                          diag.diagnosis?.diagnosis,
                          diag.diagnosis?.comment
                        )?.toUpperCase()
                      : seeNoteOnDiagnosis(
                          diag.diagnosis?.diagnosis,
                          diag.diagnosis?.comment
                        )) ||
                      (isPrelimReport &&
                        "NO PRELIMINARY INFORMATION AVAILABLE")}
                    {diag.diagnosis?.icd10_code && (
                      <> ({diag.diagnosis?.icd10_code})</>
                    )}
                  </span>
                  {diag.diagnosis?.comment && (
                    <>
                      <br />
                      <br />
                      <span className="PrintReport__diagnosis--note">
                        NOTE: {diag.diagnosis.comment}
                      </span>
                    </>
                  )}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </section>
  ) : null;
};

export default DiagnosesInformation;
